import React from 'react'

const PetOffers = () => {
  return <div>pet offers</div>
}

export default PetOffers
